module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/mainvisual-date-pc_95e284834b4add6ebe43a5182c359744.png";